import { createAction, props } from '@ngrx/store';
import { IDeliveryService } from 'src/app/shared/interfaces/deliveryService/ideliveryService';

enum DeliveryServiceActionType {
  LOAD_DELIVERYSERVICE = '[deliveryService] load deliveryService from api',
  LOAD_DELIVERYSERVICE_SUCCESS = '[deliveryService] load deliveryService from api return success',
  LOAD_DELIVERYSERVICE_ERROR = '[deliveryService] load deliveryService from api return error',
  SAVE_DELIVERYSERVICE = '[deliveryService] save deliveryService from api',
  SAVE_DELIVERYSERVICE_SUCCESS = '[deliveryService] edit deliveryService from api return success',
  EDIT_DELIVERYSERVICE = '[deliveryService] edit deliveryService from api',
  EDIT_DELIVERYSERVICE_SUCCESS = '[deliveryService] edit deliveryService from api return success',
  DELETE_DELIVERYSERVICE = '[deliveryService] delete deliveryService from api',
}
export const loadDeliveryService = createAction(
  DeliveryServiceActionType.LOAD_DELIVERYSERVICE
);
export const loadDeliveryServiceSuccess = createAction(
  DeliveryServiceActionType.LOAD_DELIVERYSERVICE_SUCCESS,
  props<{ lista: IDeliveryService[] }>()
);
export const saveDeliveryService = createAction(
  DeliveryServiceActionType.SAVE_DELIVERYSERVICE,
  props<{ deliveryService: IDeliveryService }>()
);
export const saveDeliveryServiceSuccess = createAction(
  DeliveryServiceActionType.SAVE_DELIVERYSERVICE_SUCCESS,
  props<{ deliveryService: IDeliveryService }>()
);
export const editDeliveryService = createAction(
  DeliveryServiceActionType.EDIT_DELIVERYSERVICE,
  props<{ deliveryService: IDeliveryService; id: number }>()
);
export const editDeliveryServiceSuccess = createAction(
  DeliveryServiceActionType.EDIT_DELIVERYSERVICE_SUCCESS,
  props<{ deliveryService: IDeliveryService }>()
);

export const deleteDeliveryService = createAction(
  DeliveryServiceActionType.DELETE_DELIVERYSERVICE,
  props<{ id: number }>()
);
